export const SET_ERROR = 'W2G_FORM:SET_ERROR';
export const SET_PRODUCT = 'W2G_FORM:SET_PRODUCT';
export const TOGGLE_LOADING = 'W2G_FORM:TOGGLE_LOADING';
export const UPDATE_WINNINGS = 'W2G_FORM:UPDATE_WINNINGS';
export const SET_ANOTHER_PERIOD = 'W2G_FORM:SET_ANOTHER_PERIOD';

export const setProduct = (product) => ({
    type: SET_PRODUCT,
    payload: product
});

export const setAnotherPeriod = ({ from, until }) => ({
    type: SET_ANOTHER_PERIOD,
    payload: {
        from,
        until
    }
});

export const updateWinnings = ({ transactions, winLoss }) => ({
    type: UPDATE_WINNINGS,
    payload: {
        winLoss,
        transactions
    }
});

export const toggleLoading = (isLoading) => ({
    type: TOGGLE_LOADING,
    payload: isLoading
});

export const setError = ({ error, isFetchError = false }) => ({
    type: SET_ERROR,
    payload: { error, isFetchError }
});
